module.exports = __webpack_public_path__ + "621dd9c8b26cbf7ae1c5e6f319d8c514.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/main/imgs/claims-desktop.svg
// module id = 254
// module chunks = 1